import { useEffect, useState, useSyncExternalStore } from 'react';
import type { TimerDTO } from '@devils-paw/protocol';
import { gameStore, remainingFromTimer, type GameSocketStore } from './game-store';

export function useGameStore(store: GameSocketStore = gameStore) {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}

export function useRemainingTime(timer: TimerDTO | null, clockOffsetMs: number): number | null {
  const calculate = () => remainingFromTimer(timer, Date.now(), clockOffsetMs);
  const [remaining, setRemaining] = useState<number | null>(calculate);

  useEffect(() => {
    setRemaining(calculate());
    if (timer?.deadlineAt === null || timer === null || timer.paused) return;
    const interval = window.setInterval(() => setRemaining(calculate()), 100);
    return () => window.clearInterval(interval);
  }, [timer?.deadlineAt, timer?.phaseId, timer?.paused, timer?.serverNow, clockOffsetMs]);

  return remaining;
}

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    if (typeof matchMedia !== 'function') return;
    const query = matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduced(query.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return reduced;
}
